import React, { useMemo, useState } from "react";
import { Box, Paper, Typography, Stack, Button, Divider } from "@mui/material";
import ConsultarUsuarios from "../components/ConsultarUsuarios";
import EditarUsuarios from "../components/EditarUsuarios";
import EstadisticasEstatal from "../components/EstadisticasEstatal"; // 👈 NUEVO

/** 🎨 Paleta (misma vibra que tu tabla) */
const COLORS = {
  bg: "#f5f0ff",
  white: "#ffffff",
  whiteSoft: "#fff8ff",
  subtle: "#e6dfef",
  red: "#ff3333",
  redDark: "#cc0000",
  textMain: "#2d233a",
  textMuted: "#6c6478",
};

export default function Usuarios({ userRole = "admin" }) {  // 👈 recibe prop
  // "consultar" | "editar" | "estadisticas"
  const [mode, setMode] = useState("consultar");

  const modes = useMemo(() => {
    const base = [
      { key: "consultar", label: "Consultar usuarios" },
      { key: "editar",    label: "Modificar usuarios" },
    ];
    // Tab de estadísticas solo para moderador estatal
    if (userRole === "moderador") {
      base.push({ key: "estadisticas", label: "Estadísticas" });
    }
    return base;
  }, [userRole]);

  const isConsultar = mode === "consultar";
  const isEditar = mode === "editar";
  const isEstadisticas = mode === "estadisticas";

  // Descripción dinámica según el modo activo
  const description = useMemo(() => {
    if (isConsultar)   return "Vista de consulta (tabla, filtros, exportación).";
    if (isEditar)      return "Vista de edición (buscar, seleccionar y actualizar perfil).";
    if (isEstadisticas) return "Resumen de usuarios y programas dentro de tus estados asignados.";
    return "";
  }, [isConsultar, isEditar, isEstadisticas]);

  return (
    <Box sx={{ minHeight: "100vh", backgroundColor: COLORS.bg, px: { xs: 1.5, md: 2 }, py: 2 }}>
      <Box sx={{ maxWidth: 1400, mx: "auto", width: "100%", minWidth: 0, overflowX: "hidden" }}>
        {/* Header + switch */}
        <Paper
          elevation={0}
          sx={{
            p: 2,
            borderRadius: 3,
            background: `linear-gradient(180deg, ${COLORS.whiteSoft} 0%, ${COLORS.white} 100%)`,
            border: `1px solid ${COLORS.subtle}`,
            mb: 2,
          }}
        >
          <Stack
            direction={{ xs: "column", md: "row" }}
            spacing={1.5}
            alignItems={{ xs: "flex-start", md: "center" }}
            justifyContent="space-between"
          >
            <Box>
              <Typography
                variant="h5"
                sx={{ fontWeight: 900, color: COLORS.textMain, letterSpacing: 1.2 }}
              >
                USUARIOS
              </Typography>
              <Typography sx={{ color: COLORS.textMuted, mt: 0.3 }}>
                {description}
              </Typography>
            </Box>

            <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
              {modes.map((m) => {
                const active = mode === m.key;
                return (
                  <Button
                    key={m.key}
                    variant={active ? "contained" : "outlined"}
                    onClick={() => setMode(m.key)}
                    sx={{
                      borderRadius: 2,
                      fontWeight: 900,
                      textTransform: "none",
                      ...(active
                        ? {
                            backgroundColor: COLORS.red,
                            "&:hover": { backgroundColor: COLORS.redDark },
                          }
                        : {
                            borderColor: COLORS.subtle,
                            color: COLORS.textMain,
                            backgroundColor: COLORS.white,
                            "&:hover": { backgroundColor: COLORS.whiteSoft, borderColor: COLORS.subtle },
                          }),
                    }}
                  >
                    {m.label}
                  </Button>
                );
              })}
            </Stack>
          </Stack>

          <Divider sx={{ my: 1.5, borderColor: COLORS.subtle }} />
        </Paper>

        {/* Render condicional (responsive / anti-scroll horizontal) */}
        <Box
          sx={{
            width: "100%",
            minWidth: 0, // ✅ permite que flex/grids no "empujen" el layout a lo ancho
            overflowX: "hidden", // ✅ evita scroll horizontal en la página completa
          }}
        >
          {/* Si alguna tabla interna se pasa de ancho, el scroll ocurre aquí (más UX) */}
          <Box
            sx={{
              width: "100%",
              minWidth: 0,
              overflowX: "auto",
              WebkitOverflowScrolling: "touch",
              "&::-webkit-scrollbar": { height: 10 },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: COLORS.subtle,
                borderRadius: 999,
              },
              "&::-webkit-scrollbar-track": {
                backgroundColor: "transparent",
              },
            }}
          >
            {isConsultar   && <ConsultarUsuarios />}
            {isEditar      && <EditarUsuarios />}
            {isEstadisticas && <EstadisticasEstatal />}  {/* 👈 nuevo */}
          </Box>
        </Box>
      </Box>
    </Box>
  );
}